import React from 'react';
import { SvgIcon } from '@material-ui/core';

export const PlanIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M12 2L3 7l9 5 9-5-9-5zm0 7.53L5.24 7 12 3.47 18.76 7 12 9.53zm0 2.47l-9-5v2l9 5 9-5v-2l-9 5zm0 2.47l-9-5v2l9 5 9-5v-2l-9 5z"
      fill="currentColor"
    />
  </SvgIcon>
);